import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['form', 'select']

  connect() {
    if(this.hasSelectTarget){
      $(this.selectTarget).on('hide.bs.select', this.closeSelect.bind(this));
    }
  }

  submitForm(){
    this.formTarget.submit();
  }

  closeSelect() {
    this.submitForm()
  }
}